






















































































































































































































import { defineComponent, reactive, computed, onBeforeUnmount, set } from '@vue/composition-api';
import { usePageBase, useComponentBase } from '../../base';
import { ButtonProgress } from '../../components/button-progress';
import { isNullOrWhitespace } from '../../helpers/filters';
import DropdownMenu from '../../components/dropdown-menu/dropdown-menu.vue';
import ModalPopup from '../../components/modal-popup.vue';
import { getStore } from '../../store';
import { useRouter } from '../../router';
import Vue from 'vue';
import { copy } from '../../helpers';

const componentName = 'Settings';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            loaded: false,
            saveProgress: false,
            appVersionData: null,
            keyReset: 1,

            newSectionName: null,
            showNewSectionDialog: false,
            newSectionSaveProgress: false,
            isArrangeMode: false,

            keysIdCheckboxArray: [] as any[] | null,
            selectedSectionId: null,
            selectedScreenId: null,

            screenshotPreview: {
                show: false,
                position: { top: null, bottom: null, left: null },
                src: ''
            }
        });

        let appVersionDataOriginal: any = null;

        const onCreated = () => {
            componentBase.setLoading(true);

            state.appVersionData = store.state.appVersionSummary;
            appVersionDataOriginal = copy(state.appVersionData);
            state.selectedSectionId = UISections.value[1] ? UISections.value[1].id : 0;

            sortSections();
            sortAllScreens();

            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps', routerTo: { name: 'apps' }});
                nav.push({ title: `${state.appVersionData.name} ${state.appVersionData.platform}`, routerTo: { name: 'app-versions' }});
                nav.push({ title: `Version ${state.appVersionData.version} (Build ${state.appVersionData.build}) - Settings`, extended: true });
            });

            window.addEventListener('mouseup', hideScreenshotPreview);

            state.loaded = true;

            componentBase.setLoading(false);
        }

        const updateData = async () => {
            state.appVersionData = await store.dispatch(
                'getAppVersionSummary',
                { versionId: route.value.params.versionId }
            );
            appVersionDataOriginal = copy(state.appVersionData);
            sortSections();
            sortAllScreens();
        }

        const sortSections = () => {
            state.appVersionData.sections.sort(function(a, b){return a.ordinal - b.ordinal});
        }

        const sortScreen = (section: any) => {
            if (!section.screens) {
                return;
            }
            section.screens.sort(function(a, b){return a.ordinal - b.ordinal});
        }

        const sortAllScreens = () => {
            if (!state.appVersionData.sections) {
                return;
            }
            state.appVersionData.sections.forEach(s => {
                sortScreen(s);
            });
        }

        onBeforeUnmount(() => window.removeEventListener('mouseup', hideScreenshotPreview));

        const UISections = computed(() => {
            let sections = []
            //if there is at least one key without section, generate the dummy section
            if (state.appVersionData && state.appVersionData.keys && state.appVersionData.keys.filter(x => x.sectionId == null).length > 0) {
                sections.push({ id: null, name: 'No section', screenshots : [{ id: null, name: getScreenshotName({id:null},0), keys: keys(null,null) }] });
            }

            if (state.appVersionData && state.appVersionData.sections) {
                state.appVersionData.sections.forEach((s,i) => {

                    let UIScreenshots = [
                        { id: null, imageId: null, name: getScreenshotName({id:null},0), ordinal: null, sectionId: s.id, keys: keys(s.id,null) }
                    ];

                    // generate screenshots for the view
                    if (s.screens != null) {
                        s.screens.forEach((screen, scIndex) => {
                            UIScreenshots.push({
                                id: screen.id,
                                imageId: screen.imageId,
                                name: getScreenshotName(screen, scIndex),
                                ordinal: screen.ordinal,
                                sectionId: s.id,
                                keys: keys(s.id, screen.id)
                            });
                        });
                    }

                    sections.push(
                        {   id: s.id,
                            name : s.name,
                            screenshots : UIScreenshots,
                            isFirst : i == 0,
                            isLast : i == state.appVersionData.sections.length - 1
                        }
                    );
                });
            }
            return sections;
        });

        const sectionSelectOptions = computed(() => UISections.value.filter(x => x.id) ? UISections.value.filter(x => x.id) : []);

        const screenSelectOptions = computed(() => {
            var selectedSection = UISections.value.filter(x => x.id == state.selectedSectionId)[0];
            return selectedSection ? selectedSection.screenshots : [];
        });

        const screenshotPreviewCssStyle = computed(() => {
            let position = state.screenshotPreview.position;
            return `top: ${position.top || ''}px; bottom: ${position.bottom || ''}px; left: ${position.left || ''}px;`
        });

        const keys = (sectionId: number, screenId: number) => state.appVersionData.keys && state.appVersionData.keys.filter(x => (x.sectionId == sectionId) && (x.screenId == screenId));

        const getScreenshotName = (screen: any, index : number) => {
            if (screen.id == null) {
                return "No screen";
            }
            else {
                return screen.name;
            }
        }

        const showScreenshotPreview = (evt: MouseEvent, imageId: number) => {
            if (evt.target instanceof HTMLElement) {
                let rect = evt.target.getBoundingClientRect();
                let top = Math.max(rect.top - 232, 20);
                let bottom = top + 500;
                let left = rect.right + 8;

                if (bottom > window.innerHeight - 20) {
                    top = null,
                    bottom = 20;
                }

                state.screenshotPreview.position = {
                    top: top,
                    left: left,
                    bottom: bottom
                }
                state.screenshotPreview.src = getImagePath(imageId);
                state.screenshotPreview.show = true;
            }
        }

        const hideScreenshotPreview = () => state.screenshotPreview.show = false;

        const onNewSection = () => {
            state.newSectionName = null;
            state.showNewSectionDialog = true;
        }

        const onNewSectionSave = async () => {
            let newSection = {
                id: null,
                versionId : route.value.params.versionId,
                name : state.newSectionName
            }

            state.newSectionSaveProgress = true;

            let res = await store.dispatch('updateAppSection', { section: newSection });
            if (res) {
                await updateData();
                store.commit('setUISnackbar', { type: 'success', message: `Added section: ${state.newSectionName}.` });
            }
            else {
                store.commit('setUISnackbar', { type: 'error', message: 'Error while saving data to the server. Try again.' });
            }

            state.newSectionSaveProgress = false;
            state.showNewSectionDialog = false;
        }

        const onAddScreen = async (sectionId: number) => {
            let res = await store.dispatch('addScreenInSection', { sectionId });
            if (res) {
                await updateData();
                store.commit('setUISnackbar', { type: 'success', message: `Added screen.` });
            }
            else {
                store.commit('setUISnackbar', { type: 'error', message: 'Error while saving data to the server. Try again.' });
            }
        }

        const onDeleteScreen = async (screenId : number) => {
            let res = await store.dispatch('deleteScreen', { screenId });

            if (res) {
                await updateData();
            }
            else {
                console.log("ERROR WHILE DELETING SCREEN");
            }
        }

        const onSectionDelete = async (sectionId : number) => {
            let res = await store.dispatch('deleteSection', { sectionId });

            if (res) {
                await updateData();
            }
            else {
                console.log("ERROR WHILE DELETING SECTION");
            }
        }

        const onKeysMove = async () => {
            state.keysIdCheckboxArray.forEach(id => {
                var index = state.appVersionData.keys.findIndex(x => x.id == id);
                var key = state.appVersionData.keys[index];
                set(key, 'sectionId', Number(state.selectedSectionId));
                set(key, 'screenId', Number(state.selectedScreenId) == 0 ? null : Number(state.selectedScreenId));
            });

            state.keysIdCheckboxArray = [];
            state.keyReset += 1;
        }

        const screenHasKeys = (screen: any) => state.appVersionData.keys && state.appVersionData.keys.filter(x => x.screenId == screen.id).length > 0;

        // Section arrangement

        const onUpPressedSection = (sectionId : number) => {
            let index = state.appVersionData.sections.findIndex(x => x.id == sectionId);

            let selectedSection = state.appVersionData.sections[index];
            selectedSection.ordinal--;

            let selectedPredecessor = state.appVersionData.sections[index-1]
            selectedPredecessor.ordinal++;

            sortSections();
        }

        const onDownPressedSection = (sectionId : number) => {
            let index = state.appVersionData.sections.findIndex(x => x.id == sectionId);

            let selectedSection = state.appVersionData.sections[index];
            selectedSection.ordinal++;

            let selectedSuccessor = state.appVersionData.sections[index+1]
            selectedSuccessor.ordinal--;

            sortSections();
        }

        // Screenshots arrangement

        const onUpPressedScreen = (sectionId: number, screenId : number) => {
            let section = state.appVersionData.sections.find(x => x.id == sectionId);

            let index = section.screens.findIndex(x => x.id == screenId);

            let selectedScreen = section.screens[index];
            selectedScreen.ordinal--;

            let selectedPredecessor = section.screens[index-1]
            selectedPredecessor.ordinal++;

            sortScreen(section);
        }

        const onDownPressedScreen = (sectionId: number, screenId : number) => {
            let section = state.appVersionData.sections.find(x => x.id == sectionId);

            let index = section.screens.findIndex(x => x.id == screenId);

            let selectedScreen = section.screens[index];
            selectedScreen.ordinal++;

            let selectedSuccessor = section.screens[index+1]
            selectedSuccessor.ordinal--;

            sortScreen(section);
        }

        const onArrangeModeClick = () => {
            document.body.classList.add('arrangement-mode');
            state.isArrangeMode = true;
        }

        const onSelectSectionChanged = () => state.selectedScreenId = null;

        const onArrangeBack = async () => {
            document.body.classList.remove('arrangement-mode');
            state.isArrangeMode = false;

            await updateData();
            //bring back data as they were from db
            state.keyReset += 1;
            state.keysIdCheckboxArray = [];
            state.selectedSectionId = UISections.value[1] ? UISections.value[1].id : null;
            state.selectedScreenId = null;
        }

        const onArrangeSave = async () => {
            let dataToUpdate = prepareDataForArrangeSave();
            let res = await store.dispatch('updateAppSectionsTranslations', { sectionsTranslations: dataToUpdate });

            if (res) {
                await updateData();
                document.body.classList.remove('arrangement-mode');
                state.isArrangeMode = false;
            }
            else {
                console.log("ERROR WHILE DELETING SECTION");
            }
        }

        const prepareDataForArrangeSave = () => {
            let dataToUpdate = copy(state.appVersionData);

            dataToUpdate.keys = dataToUpdate.keys && dataToUpdate.keys.filter(k => {
                let kOriginal = appVersionDataOriginal.keys.find(x => x.id == k.id);
                if (kOriginal && (kOriginal.screenId != k.screenId || kOriginal.sectionId != k.sectionId)) {
                    return true;
                }
                return false;
            }) || [];

            dataToUpdate.sections.forEach(s => {
                s.screens = s.screens && s.screens.filter(screen => {
                    let sectionOriginal = appVersionDataOriginal.sections.find(x => x.id == s.id);
                    let screenOriginal = sectionOriginal && sectionOriginal.screens.find(x => x.id == screen.id);
                    if (screenOriginal && screenOriginal.ordinal != screen.ordinal) {
                        return true;
                    }
                    return false;
                }) || [];
            });

            dataToUpdate.sections = dataToUpdate.sections && dataToUpdate.sections.filter(s => {
                let sectionOriginal = appVersionDataOriginal.sections.find(x => x.id == s.id);
                if (sectionOriginal && (sectionOriginal.ordinal != s.ordinal || s.screens.length > 0)) {
                    return true;
                }
                return false;
            }) || [];
            
            return dataToUpdate;
        }

        const editSectionLink = (sectionId: number) => {
            return { name: 'app-section-edit', params: { sectionId: sectionId }};
        }

        const getImagePath = (imageId : number) => {
            if (imageId) {
                return `/images/${imageId}/origin`;
            }
        }

        onCreated();

        return {
            state,
            updateData,
            UISections,
            sectionSelectOptions,
            screenSelectOptions,
            screenshotPreviewCssStyle,
            keys,
            getScreenshotName,
            showScreenshotPreview,
            hideScreenshotPreview,
            onNewSection,
            onNewSectionSave,
            onAddScreen,
            onDeleteScreen,
            onSectionDelete,
            onKeysMove,
            screenHasKeys,
            onUpPressedSection,
            onDownPressedSection,
            onUpPressedScreen,
            onDownPressedScreen,
            onArrangeModeClick,
            onSelectSectionChanged,
            onArrangeBack,
            onArrangeSave,
            editSectionLink,
            getImagePath,
            isNullOrWhitespace
        }
    },

    components: { ButtonProgress, DropdownMenu, ModalPopup }
})

